
import { Component, Prop, Vue } from 'vue-property-decorator';
import MemberCollection from '@/components/Member/MemberCollection.vue';
import { Route } from 'vue-router';
import api from '@/api';
import Util from '@/utils/util';

const { member } = api;

@Component({
  components: {
    MemberCollection,
  },
})
export default class InvitedList extends Vue {
  @Prop({ required: true }) private userId!: string;

  private data = { data: [], totalCount: 0, pageSize: 20, pageNo: 0 };

  private filter = {
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
  };

  private async query() {
    const query = {
      pageSize: `${this.filter.pageSize}`,
      pageNo: `${this.filter.pageNo}`,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    }
    await this.requestData();
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async requestData() {
    const { data } = await member.listInvitedUsers(this.userId, this.filter);
    this.data = data;
  }

  private async updatePage(page: number) {
    this.filter.pageNo = page;
    await this.query();
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: (vm: InvitedList) => void) => void,
  ) {
    await next(async (vm) => {
      await vm.requestData();
    });
  }
}
